(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name trainingDiscrepancy.controller:TrainingDiscrepancyCtrl
     *
     * @description
     *
     */
    angular
        .module('trainingDiscrepancy')
        .directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
        .controller('TrainingDiscrepancyCtrl', TrainingDiscrepancyCtrl);

    function TrainingDiscrepancyCtrl(applicationConstants, CommonMasterData, TrainingDiscrepancyService,
                                     MessageService, CommonLogicService, EventManagerService, $stateParams, StorageServices, TrainingProgramsService) {
        var vm = this;
        vm.ctrlName = 'TrainingDiscrepancyCtrl';

        vm.model = {
            searchPanelToggle: true,
            searchCriteria: {
                acType: null,
                location: null,
                category: null,
                fromDate: CommonLogicService.getStartEndDateOfRelativeToMonth(null, 'NEXT', '0', 'START'),
                toDate: CommonLogicService.getStartEndDateOfRelativeToMonth(null, 'NEXT', '0', 'END')
            },
            refineParam : {
            	acType: TrainingDiscrepancyService.getDefaultAircraftType(),
                location: TrainingDiscrepancyService.getDefaultTrainingLocation(),
                category: TrainingDiscrepancyService.getDefaultTrainingCategory(),
            },
            masterList: {
                airportList: [],
                categoryList: [],
                aircraftTypes:[],
                airportListWithDefault: [],
                categoryListWithDefault: [],
                aircraftTypesWithDefault:[]
            },
            suggestedCrew:[],
            trainingList: [],
            initialSearchDone: false,
            selectedTraining: null,
            disModel:TrainingDiscrepancyService.getModifiedForDisplay(null),
            editorMode: applicationConstants.EDITOR_STATUS.ADD
        };

        //Event register
        EventManagerService.registerEventListener(EventManagerService.EVENT.TRAINING_ASSIGN_CREW.DISCREPANCY_TRAINING_ASSIGN_SUCCESS, searchDiscrepancyTrainings);

        vm.clickOnSearch = function () {
            vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
            vm.model.initialSearchDone = false;
        };

        vm.setToDate = function() {
        	if (moment(vm.model.searchCriteria.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY") != undefined) {
        		vm.model.searchCriteria.toDate = moment(vm.model.searchCriteria.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
        	}
        	setRefineParam();
        }
        
        
        function setRefineParam(){
        	//set location
        	var location = null;
        	if(!!vm.model.searchCriteria.location && vm.model.searchCriteria.location != " "){
        		location = _.find(vm.model.masterList.airportListWithDefault, {
        			airPortName : vm.model.searchCriteria.location.airPortName
                  });
        		         	
        	} else {
        		location = _.find(vm.model.masterList.airportListWithDefault, {
        			airPortName : "ANY"
                  });
        	}
        	vm.model.refineParam.location = location;
        	
        	//set category
        	var category = null;
        	if(!!vm.model.searchCriteria.category){
        		category = _.find(vm.model.masterList.categoryListWithDefault, {
        			categoryCode : vm.model.searchCriteria.category.categoryCode
                  });
        		         	
        	} else {
        		category = _.find(vm.model.masterList.categoryListWithDefault, {
        			categoryCode : "ANY"
                  });
        	}
        	vm.model.refineParam.category = category;
        	
        	//set actype
        	var acType = null;
        	if(!!vm.model.searchCriteria.acType){
        		acType = _.find(vm.model.masterList.aircraftTypesWithDefault, {
        			airCraftType : vm.model.searchCriteria.acType.airCraftType
                  });
        		         	
        	} else {
        		acType = _.find(vm.model.masterList.aircraftTypesWithDefault, {
        			airCraftType : "ANY"
                  });
        	}
        	vm.model.refineParam.acType = acType;
        	
        	
        }
        
        vm.selectATrn = function (selectedRow) {
            vm.model.disModel = TrainingDiscrepancyService.getModifiedForDisplay(selectedRow);
            vm.model.selectedTraining = selectedRow;
            TrainingDiscrepancyService.loadSuggestedCrew(selectedRow);
            TrainingDiscrepancyService.suggestedCrew.subscribe(function (suggestedCrew) {
                vm.model.suggestedCrew = suggestedCrew;
            });
        };

        vm.setSuggestedCrew = function (selectedRowData) {
            TrainingDiscrepancyService.assignTraining(vm.model.selectedTraining, selectedRowData);
        };

        vm.searchTrdiscrepancy = function (params) {
            vm.model.trainingList = [];
            vm.model.searchCriteria = params;
            vm.model.searchCriteria.pageSize = 100000;
            vm.model.searchCriteria.startPosition = 1;
            TrainingDiscrepancyService.setSearchCriteria(vm.model.searchCriteria);
            searchDiscrepancyTrainings();
        };

        vm.changeCriteria = function () {
            if (vm.model.initialSearchDone === true) {
                vm.model.trainingList = TrainingDiscrepancyService.refineTrainingData(vm.model.refineParam);
            }
        };

      function setSearchFields() {
        if (!!$stateParams) {
          var tabLocalData = StorageServices.getTabData('trainingDiscrepancy');
          if (!!tabLocalData && !!tabLocalData._loadTrainingDiscrepancyParams) {
            vm.model.searchCriteria.fromDate = tabLocalData._loadTrainingDiscrepancyParams.fromDate;
            vm.model.searchCriteria.toDate = tabLocalData._loadTrainingDiscrepancyParams.toDate;
            vm.model.searchCriteria.acType = tabLocalData._loadTrainingDiscrepancyParams.acType;
            vm.model.searchCriteria.acType = _.find(vm.model.masterList.aircraftTypes, {airCraftType:tabLocalData._loadTrainingDiscrepancyParams.acType});
            vm.model.searchCriteria.category = _.find(vm.model.masterList.categoryList, {categoryCode:tabLocalData._loadTrainingDiscrepancyParams.category});
            vm.searchTrdiscrepancy(vm.model.searchCriteria);
          }
        }

      }


        function searchDiscrepancyTrainings() {
            vm.model.trainingList = [];
            var tempKeep = angular.copy(vm.model.selectedTraining);
            vm.model.selectedTraining = null;
            TrainingDiscrepancyService.getTrainingDescrepancy(
                function (trainingList) {
                    updateDescList(trainingList);
                    vm.model.selectedTraining = tempKeep;
                    vm.model.searchPanelToggle = false;
                    vm.model.initialSearchDone = true;
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function updateDescList(trainingList) {
            angular.forEach(trainingList, function (trDesc) {
              if(!((trDesc.totalAssTrainee === trDesc.totalTraineeReq) && (trDesc.totalAssTrainer === trDesc.totalTrainerReq))){ // discrepancy only
                  vm.model.trainingList.push(trDesc);
              }
            });
            vm.model.isElasticLoadingVisible = false;
        }


        CommonMasterData.getAircraftModels(function (airCraftList) {
          TrainingDiscrepancyService.setAirCraftTypes(airCraftList);
          vm.model.masterList.aircraftTypes = TrainingDiscrepancyService.getAirCraftTypes();
          vm.model.masterList.aircraftTypesWithDefault = TrainingDiscrepancyService.getAirCraftTypesWithDefault();
        }, function () {
          console.log('Aircraft type retrieval error');
        }); 

        CommonMasterData.getAirportList(function (airportList) {
            TrainingDiscrepancyService.setTrainingLocation(airportList);
            vm.model.masterList.airportList = TrainingDiscrepancyService.getTrainingLocation();
            vm.model.masterList.airportListWithDefault = TrainingDiscrepancyService.getTrainingLocationWithDefault();
        }, function (error) {
        });

          CommonMasterData.getTrainingCategories(function (categoryList) {
            TrainingDiscrepancyService.setTrainingCategory(categoryList);
            vm.model.masterList.categoryList = TrainingDiscrepancyService.getTrainingCategory();
            vm.model.masterList.categoryListWithDefault = TrainingDiscrepancyService.getTrainingCategoryWithDefault();
            setSearchFields();
          }, function (error) {
          });



    }
}());
